import DayjsUtils from '@date-io/dayjs';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from '@material-ui/icons/Search';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import * as dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from "react";
import { useActions, useValues } from 'kea';

import { replaylogic, preferenceslogic } from 'src/store/global';
import vehiclelogic from 'src/store/vehicle';
import { minHistoryDate } from 'src/utils/constants';

const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px",
		maxHeight: 400
	},
	limitFont: {
		fontSize: 13
	}
});



export default function Replay({ vehicle }) {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { setVehicle: replaySetVehicle, setMax } = useActions(replaylogic);

	const { replay } = useValues(vehiclelogic);
	const { fetchReplay } = useActions(vehiclelogic);

	const { replay: replayPref } = useValues(preferenceslogic);
	const { setReplay: setReplayPref } = useActions(preferenceslogic);


	const [startDate, handleStartDateChange] = useState(new Date());
	const [endDate, handleEndDateChange] = useState(new Date());

	useEffect(() => {
		if (replay?.status?.length > 0) {
			replaySetVehicle(replay);
			setReplayPref({ ...replayPref, show: true });
			setMax(replay.status.length);
		}
	}, [replay])

	const handleSearch = async () => {
		if (dayjs(startDate).isBefore(endDate)) {
			fetchReplay({
				_id: vehicle._id,
				start: startDate,
				stop: endDate
			})
		} else {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
		}
	}

	const handleQuickAction = (duration) => () => {
		if (dayjs(startDate).isAfter(endDate)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return;
		}
		if (duration === 'today') {
			fetchReplay({
				_id: vehicle._id,
				start: dayjs().startOf('day'),
				stop: dayjs().endOf('day')
			})
			handleStartDateChange(dayjs().startOf('day'));
			handleEndDateChange(dayjs().endOf('day'));
		} else if (duration === 'yesterday') {
			fetchReplay({
				_id: vehicle._id,
				start: dayjs().subtract(1, 'day').startOf('day'),
				stop: dayjs().subtract(1, 'day').endOf('day')
			})
			handleStartDateChange(dayjs().subtract(1, 'day').startOf('day'));
			handleEndDateChange(dayjs().subtract(1, 'day').endOf('day'));
		} else if (duration === '3 days') {
			fetchReplay({
				_id: vehicle._id,
				start: dayjs().subtract(3, 'day').startOf('day'),
				stop: dayjs().endOf('day')
			})
			handleStartDateChange(dayjs().subtract(3, 'day').startOf('day'));
			handleEndDateChange(dayjs().endOf('day'));
		} else if (duration === 'week') {
			fetchReplay({
				_id: vehicle._id,
				start: dayjs().subtract(1, 'week').startOf('day'),
				stop: dayjs().endOf('day')
			})
			handleStartDateChange(dayjs().subtract(1, 'week').startOf('day'));
			handleEndDateChange(dayjs().endOf('day'));
		}
	}

	return (
		<>
			<TableContainer className={classes.table}>
				<Table stickyHeader size="small" aria-label="a dense table">
					<TableHead>
						<TableRow key={"start-date"}>
							<TableCell align="right">
								<b>{`Start Date: `}</b>
							</TableCell>
							<TableCell align="left" style={{ paddingRight: 0, fontSize: 22 }}>
								<MuiPickersUtilsProvider utils={DayjsUtils}>
									<DateTimePicker
										autoOk
										ampm={false}
										variant="inline"
										format="DD/MM/YYYY HH:mm"
										value={startDate}
										minDate={minHistoryDate}
										disableFuture
										onChange={handleStartDateChange}
									/>
								</MuiPickersUtilsProvider>
							</TableCell>
						</TableRow>
						<TableRow key={"end-date"}>
							<TableCell align="right">
								<b>{`End Date: `}</b>
							</TableCell>
							<TableCell align="left" style={{ paddingRight: 0, fontSize: 22 }}>
								<MuiPickersUtilsProvider utils={DayjsUtils}>
									<DateTimePicker
										autoOk
										ampm={false}
										variant="inline"
										format="DD/MM/YYYY HH:mm"
										value={endDate}
										disableFuture
										minDate={startDate}
										maxDate={startDate + 3456000000}
										onChange={handleEndDateChange}
										minDateMessage={'Date should not be before \'Start date\''}
									/>
								</MuiPickersUtilsProvider>
							</TableCell>
						</TableRow>
						<TableRow key={"search-button"}>
							<TableCell colSpan={2} align="right" style={{ paddingLeft: 0 }}>
								<div style={{
									display: 'flex',
									justifyContent: 'right'
								}}>
									<div>
										<Button
											color="primary"
											size="small"
											className={classes.button}
											onClick={handleQuickAction('today')}
										>
											Today
										</Button>
										<Button
											color="primary"
											size="small"
											className={classes.button}
											onClick={handleQuickAction('yesterday')}
										>
											Yesterday
										</Button>
										<Button
											color="primary"
											size="small"
											className={classes.button}
											onClick={handleQuickAction('3 days')}
										>
											3 Days
										</Button>
										<Button
											color="primary"
											size="small"
											className={classes.button}
											onClick={handleQuickAction('week')}
										>
											Week
										</Button>
									</div>
									<div style={{ width: '50px' }} />
									<Button
										disabled={(endDate - startDate) > 3456000000}
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<SearchIcon />}
										onClick={handleSearch}
									>
										Search
									</Button>
								</div>
							</TableCell>
						</TableRow>
					</TableHead>
				</Table>
			</TableContainer>

		</>
	);
}
